var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 371 211"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F2483",
    strokeLinecap: "round",
    strokeWidth: 12,
    d: "M-5 182.607C331.5 283 299.405.304 244.5 7c-71.876 8.766 6.192 164.709 118.131 151.057m0 0-26.127-21.777m26.127 21.777-15.783 24.55"
  })));
};
export default SvgArrowRight;